/* eslint-disable */
import React from "react";
import { createUseStyles } from "react-jss";
import MediaIcon from "Components/MediaIcon";

import PanoIcon from "Assets/images/pano_icon.svg";
import Video from "Assets/images/video_icon.svg";
import PhotoIcon from "Assets/images/photo_icon.svg";
import InstagramIcon from "Assets/images/instagram.svg";
import CampusReelIcon from "Assets/images/campusreels.svg";
import StopIcon from "Assets/images/thumb_stop.svg";
import { MEDIA_TYPES, NETWORK_TYPES } from "../../constants";
import styles from "./styles";

interface ResultProps {
  result: any;
  onClick: (e, result: any) => void;
}

const getIcon = (mediaType: string, network: string, type: string) => {
  if (network === NETWORK_TYPES.instagram) return {icon: InstagramIcon, testClass: 'instagramIcon'};
  if (type === "campusreel") return {icon: CampusReelIcon, testClass: 'campusReelIcon'};
  switch (mediaType) {
    case MEDIA_TYPES.PANO:
    case MEDIA_TYPES.PANORAMA:
      return {icon: PanoIcon, testClass: 'panoIcon'};
    case MEDIA_TYPES.VIDEO:
      return {icon: Video, testClass: 'videoIcon'};
    case MEDIA_TYPES.PHOTO:
      return {icon: PhotoIcon, testClass: 'photoIcon'};
    default:
      return {icon: StopIcon, testClass: 'stopIcon'};
  }
};

const ResultCell = ({ result, onClick }: ResultProps) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles();
  const media = result?.media;
  const mediaType = result?.media_type;
  const type = result?.media?.type;
  const network = result?.media?.network;
  const imageUrl =
    mediaType === MEDIA_TYPES.STOP_DESCRIPTION ? media : media?.smallurl;

  const iconAsset = getIcon(mediaType, network, type);

  return media ? (
    <button
      tabIndex={0}
      className={classes.cellContainer}
      onClick={(e) => {e.stopPropagation; onClick(e, result)}}
    >
      {network === NETWORK_TYPES.instagram ? (
        <div className={classes.instagram} onClick={() => {}}>
          <iframe
            className={classes.iframe}
            src={`https://www.instagram.com/p/${
              mediaType === MEDIA_TYPES.PHOTO ? media?.url : media?.videoid
            }/embed`}
            frameBorder="0"
            allowFullScreen=""
            scrolling="no"
          />
          <div className={classes.thumbnailIcon} data-testid={iconAsset.testClass}>
            <MediaIcon Icon={InstagramIcon} showBackground={false} />
          </div>
        </div>
      ) 
      : type === 'campusreel' ? (
        <div className={classes.instagram}>
          <iframe
            src={result?.media?.url}
            title={result?.media?.title}
            tabIndex={-1}
            className={classes.campusreel}
            allowFullScreen
          />
          <div className={classes.thumbnailIcon} data-testid={iconAsset.testClass}>
            <MediaIcon Icon={iconAsset.icon} showBackground={false} className={type === 'campusreel' ? classes.campusReelIcon : ''}/>
          </div>
      </div>
      ) : (
        <div
          className={classes.img}
          style={{
            background: `url(${imageUrl}) no-repeat center center / cover`,
          }}
          onClick={() => {}}
        >
          <div className={classes.thumbnailIcon} data-testid={iconAsset.testClass}>
            <MediaIcon
              Icon={iconAsset.icon}
              showBackground={false}
            />
          </div>
        </div>
      )}
      <div className={classes.title}>
        {mediaType === MEDIA_TYPES.STOP_DESCRIPTION
          ? result.destination?.title
          : media?.title}
      </div>
    </button>
  ) : null;
};

export default ResultCell;
try {
    // @ts-ignore
    ResultCell.displayName = "ResultCell";
    // @ts-ignore
    ResultCell.__docgenInfo = { "description": "", "displayName": "ResultCell", "props": { "result": { "defaultValue": null, "description": "", "name": "result", "required": true, "type": { "name": "any" } }, "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": true, "type": { "name": "(e: any, result: any) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/SearchAI/ResultCell.tsx#ResultCell"] = { docgenInfo: ResultCell.__docgenInfo, name: "ResultCell", path: "src/shared/components/SearchAI/ResultCell.tsx#ResultCell" };
}
catch (__react_docgen_typescript_loader_error) { }